// actionTypes.js
export const SET_VALUE_MESSAGE = "SET_VALUE_MESSAGE";
export const SET_STATUT_MESSAGE = "SET_STATUT_MESSAGE";
export const SET_ACTIF_MESSAGE = "SET_ACTIF_MESSAGE";

export const SET_CURRENT_PAGE_MESSAGE = "SET_CURRENT_PAGE_MESSAGE";
export const SET_ORDER_MESSAGE = "SET_ORDER_MESSAGE";
export const SET_SORT_FIELD_MESSAGE = "SET_SORT_FIELD_MESSAGE";
